import React, { useState, useEffect } from "react";
import { IconButton } from "@mui/material";
import { toast } from "react-toastify";
import api from "../../utils/api";
import TooltipAction from "../TooltipAction/TooltipAction";
import { useUpgradeModal } from "../../providers/UpgradeModalProvider";

export const FavoriteButton = ({
  talent,
  heartIcon,
  heartInactiveIcon,
  iconSize = { width: "25px", height: "25px" },
  onUpdateFavorites
}) => {
  const [isActive, setIsActive] = useState(talent?.favorited || false);
  const [tooltip, setTooltip] = useState({ visible: false, message: "" });
  const { showUpgradeModal } = useUpgradeModal();

  // Update state when talent.favorited changes
  useEffect(() => {
    setIsActive(talent?.favorited || false);
  }, [talent?.favorited]);

  const handleFavorite = async (id) => {
    try {
      await api.post(`/companies/favorites`, {
        data: {
          attributes: {
            talentId: id,
          },
        },
      });
    } catch (error) {
      // Check if error is due to limit exceeded
      const errorMessage = error?.response?.data?.errors?.[0]?.detail ||
                          error?.response?.data?.errors?.[0]?.title ||
                          error?.response?.data?.message;

      const isLimitExceeded = errorMessage?.toLowerCase().includes('limite') ||
                              errorMessage?.toLowerCase().includes('limit') ||
                              error?.response?.status === 403;

      if (isLimitExceeded) {
        toast.error('Você atingiu o limite de favoritos do seu plano');
        showUpgradeModal('favorites', 'Limite de favoritos esgotado');
      } else {
        toast.error(`Ocorreu um erro ao favoritar o talento. ${errorMessage || error.message}`);
      }

      // Revert the UI state if API call fails
      setIsActive(false);
    }
  };

  const handleDellFavorite = async (id) => {
    try {
      await api.delete(`/companies/favorites/${id}`);

      if (onUpdateFavorites) {
        onUpdateFavorites();
      }
    } catch (error) {
      toast.error(`Ocorreu um erro ao desfavoritar o talento. ${error}`);
      // Revert the UI state if API call fails
      setIsActive(true);
    }
  };

  const toggleHeart = () => {
    const newValue = !isActive;
    setIsActive(newValue);

    // Show tooltip with correct message
    setTooltip({
      visible: true,
      message: newValue ? "Favoritou" : "Desfavoritou"
    });

    // Hide tooltip after 1.5 seconds
    setTimeout(() => {
      setTooltip({ visible: false, message: "" });
    }, 1500);

    if (newValue) {
      handleFavorite(talent?.id);
    } else {
      handleDellFavorite(talent?.id);
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <IconButton onClick={toggleHeart}>
        <img
          src={isActive ? heartIcon : heartInactiveIcon}
          alt="heart"
          style={iconSize}
        />
      </IconButton>
      <TooltipAction
        message={tooltip.message}
        visible={tooltip.visible}
      />
    </div>
  );
};

